import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  blockName: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  titleText: PropTypes.string,
};

const defaultProps = {
  blockName: '',
  titleText: '',
};

function Features(props) {
  const groupList = [];

  for (let i = 0; i < props.items.length; i += 3) {
    groupList.push(props.items.slice(i, i + 3));
  }

  return (
    <div className={props.blockName ? `${props.blockName}_wysiwyg` : ''}>
      <h3>{props.titleText}</h3>
      <div className={props.blockName ? `${props.blockName}_groupList` : ''}>
        {groupList.map((group) => (
          <ul
            key={`group-${group[0]}`}
            className={props.blockName ? `${props.blockName}_groupListItem` : ''}
          >
            {group.map((item) => (
              <li key={`item-${item}`}>{item}</li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
}

Features.propTypes = propTypes;
Features.defaultProps = defaultProps;

export default Features;
